/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import isEqual from 'lodash.isequal';
import isNil from 'lodash.isnil';
import {translate} from '@ion/core/src/locale/locale';
import {url} from '@ion/core/src/services/ConnectUtils';
import {
  Entity,
  EntityStatus,
  Link
} from '@ion/core/src/types/entities';
import {
  ServiceError
} from '@ion/core/src/types/services';
import {errorAddOptions, errorOptions} from '../../../prompts/constants';

const checkStatus = (array: Link[], value: EntityStatus): boolean => {
  return array.some(arr => arr.status === value);
};

export const assetError = (err?: ServiceError, deviceName?: string) => ({
  ...errorOptions,
  message : !isNil(err) ? formatAssetErrorMessage(err, deviceName) : 'common:editors.shared.errorCreated'
});

export const formatAssetErrorMessage = ({errorText}: ServiceError, deviceName?: string): string => {
  if (errorText) {
    return translate('admin-assets:import.errors.restrictDeviceState', {deviceName});
  }
  return translate('notifications:error.client');
};

const isActiveStateError = (error: ServiceError) => isEqual(error?.url, url(`/assets/${error?.url?.replace(/\D/g, '')}/devices`)) &&
  isEqual(error?.errorCode, 400);

const getCategoryError = () => ({
  ...errorOptions,
  message : 'admin-assets:form.assetCategory.errorText'
});

export const determineAssetError = (error: ServiceError, deviceName: string, device?: Link[]) => {
  if (!isActiveStateError(error)) {
    const {errorText} = error || {};
    if (errorText?.includes?.('assetCategory')) {
      return getCategoryError();
    } else {
      return errorAddOptions(Entity.asset, error);
    }
  }

  const isActiveDevice = checkStatus(device, EntityStatus.Enabled);
  if (error && isActiveDevice) {
    return errorAddOptions(Entity.asset, error);
  }
  return assetError(error, deviceName);
};
